import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { Button, Link, List, ListItem } from '@material-ui/core';

import { useGetTaskAuditLog } from '../Task.hooks';
import { Task, TaskAuditLog } from '../Task.interface';
import TaskAuditListItem from './TaskAuditLogListItem';

const StyledList = styled(List)`
  .load-more {
    /* display: flex; */
    justify-content: center;
  }
`;

const TaskAuditLogList: React.FC<{ task: Task }> = ({ task }) => {
  const limit = 10;
  const [page, setPage] = useState(0);
  const taskIdRef = useRef(task.id);
  const [taskAuditLogs, setTaskAuditLogs] = useState<TaskAuditLog[]>([]);
  const {
    taskAuditLogList,
    isLoading,
    loadingError,
    getAuditLog
  } = useGetTaskAuditLog(task.id || 0);
  useEffect(() => {
    if (task.id !== taskIdRef.current) {
      // task Id changed from previous
      taskIdRef.current = task.id;
      getAuditLog({ page: 0, limit }); // fetch updated status change
    } else {
      getAuditLog({ page, limit }); // get next page
    }
  }, [getAuditLog, page, task]);
  useEffect(() => {
    if (taskAuditLogList && taskAuditLogList.data) {
      setTaskAuditLogs(taskAuditLogs =>
        [
          ...(taskAuditLogList.page === 0 ? [] : taskAuditLogs),
          ...taskAuditLogList.data.filter(
            newLog =>
              // don't insert log if it already exists; occurs when partial page load
              !taskAuditLogs.find(log => log.id === newLog.id)
          )
        ].sort(
          // resort the list after appending statuses
          (a, b) =>
            new Date(b.created).getTime() - new Date(a.created).getTime()
        )
      );
    }
  }, [taskAuditLogList]);
  return (
    <StyledList>
      {taskAuditLogs.map(log => (
        <TaskAuditListItem log={log} key={log.id} />
      ))}
      {taskAuditLogList && taskAuditLogList.total > (page + 1) * limit && (
        <ListItem className='load-more'>
          <Button onClick={() => setPage(page + 1)} color='primary'>
            Load More
          </Button>
        </ListItem>
      )}
    </StyledList>
  );
};

export default TaskAuditLogList;
